var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 50,
    viewBox: "0 0 99 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 37.5H57.25V35C57.25 32.9289 55.5711 31.25 53.5 31.25H46C43.9289 31.25 42.25 32.9289 42.25 35V37.5H39.75V35C39.75 31.5483 42.5482 28.75 46 28.75H53.5C56.9517 28.75 59.75 31.5483 59.75 35V37.5ZM49.75 26.25C45.6079 26.25 42.25 22.8921 42.25 18.75C42.25 14.6079 45.6079 11.25 49.75 11.25C53.8921 11.25 57.25 14.6079 57.25 18.75C57.25 22.8921 53.8921 26.25 49.75 26.25ZM49.75 23.75C52.5114 23.75 54.75 21.5114 54.75 18.75C54.75 15.9886 52.5114 13.75 49.75 13.75C46.9886 13.75 44.75 15.9886 44.75 18.75C44.75 21.5114 46.9886 23.75 49.75 23.75Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.71dfe086cd7c53d8398c6b8700515b42.svg";
export { ForwardRef as ReactComponent };